<template src="./template.html"></template>
<script>
export default {
  name: 'form-control',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Array, Number, Object, Date],
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    name: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    autocomplete: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: false,
    },
  },
  computed: {
    inputType() {
      return this.type.toLowerCase()
    },
    nonSpecificType() {
      return this.inputType !== 'tel' && this.inputType !== 'select' && this.inputType !== 'textarea' && this.inputType !== 'date' && this.inputType !== 'birthday' && this.inputType !== 'googleaddress'
    },
  },
  data() {
    return {
      hasFocus: false,
      innerValue: this.value,
    }
  },
  watch: {
    value() {
      this.innerValue = this.value
    },
  },
  methods: {
    onChange() {
      this.$emit('input', this.innerValue)
      this.$emit('change', this.innerValue)
    },
    giveFocus() {
      this.$refs.inputEl.focus()
    },
    onFocus() {
      this.hasFocus = true
    },
    onBlur() {
      this.hasFocus = false
    },
  },
  mounted() {
    this.innerValue = this.value

    if (this.type === 'Select' && this.options && this.options.length) {
      this.options.unshift({
        label: this.label,
        value: undefined,
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/FormControl/index.vue